import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ITask, ITasksStatus } from '@fi-shared/fi-task-shared/fi-task-shared';
import { ITaskSummary } from '@fi-shared/fi-task-shared/tasks-status/tasks-status';
import { TasksStatusType } from '@fi-shared/fi-task-shared/tasks-status/tasks-status-type';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'fi-tasks-status',
    template: `
        <div class="tasks-status-wrapper">
            <fi-tasks-status-summary
                class="fi-tasks-status-card"
                [tasksSummary]="tasksSummary"
            ></fi-tasks-status-summary>
            <fi-tasks-status-in-progress
                class="fi-tasks-status-card"
                [tasks]="tasksInProgress$.asObservable() | async"
                (taskPropertyChanged)="recalculateTasks()"
                (tasksDeleted)="onTasksDeleted($event)"
            ></fi-tasks-status-in-progress>
            <fi-tasks-status-completed
                class="fi-tasks-status-card"
                [tasks]="tasksCompleted$.asObservable() | async"
                (taskPropertyChanged)="recalculateTasks()"
                (tasksDeleted)="onTasksDeleted($event)"
            ></fi-tasks-status-completed>
            <!--
            <fi-tasks-status-archived class="fi-tasks-status-card" 
                                      [tasks]="tasksArchived"
                                      (taskPropertyChanged)="recalculateTasks()"
                                      (tasksDeleted)="onTasksDeleted($event)"
            ></fi-tasks-status-archived>
--></div>
    `,
    styleUrls: ['./tasks-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TasksStatusComponent implements OnInit {
    @Input() tasksStatus: ITasksStatus;

    tasksInProgress$ = new BehaviorSubject<ITask[]>([]);
    tasksCompleted$ = new BehaviorSubject<ITask[]>([]);
    //tasksArchived: ITask[] = [];

    tasksSummary: ITaskSummary[] = [];

    constructor() {}

    ngOnInit() {
        this.recalculateTasks();
    }

    recalculateTasks() {
        const tasksInProgress = [];
        const tasksCompleted = [];
        //this.tasksArchived = [];
        this.tasksStatus.Tasks.forEach((task) => {
            if (task.IsArchived) {
                //this.tasksArchived.push(task);
            } else if (task.IsCompleted) {
                tasksCompleted.push(task);
            } else {
                tasksInProgress.push(task);
            }
        });

        this.tasksSummary = [];
        this.tasksSummary.push({
            statusType: TasksStatusType.InProgress,
            count: tasksInProgress.filter((task) => !task.IsDeadlinePassed).length,
        });
        this.tasksSummary.push({
            statusType: TasksStatusType.Overdue,
            count: tasksInProgress.filter((task) => task.IsDeadlinePassed).length,
        });
        this.tasksSummary.push({
            statusType: TasksStatusType.Completed,
            count: tasksCompleted.length,
        });
        /*        this.tasksSummary.push({
            statusType: TasksStatusType.Archived,
            count: this.tasksArchived.length,
        })*/
        this.tasksInProgress$.next(tasksInProgress);
        this.tasksCompleted$.next(tasksCompleted);
    }

    onTasksDeleted(deletedTasks: ITask[]) {
        deletedTasks.forEach((task) => {
            this.tasksStatus.Tasks.splice(this.tasksStatus.Tasks.indexOf(task), 1);
        });
        this.recalculateTasks();
    }
}
